import { TextArea as PomodoroTextArea } from '@ifood/pomodoro-components';
import { useField, useFormikContext } from 'formik';
import React, { Ref, forwardRef } from 'react';
import { useEffectOnce } from 'react-use';

import { useShareForwardedRef } from 'hooks/shared-forward-ref';
import { FieldName } from 'types/form';
import { PropsOf } from 'types/jsx';

export type TextAreaProps = {
  name: FieldName<string>;
} & PropsOf<typeof PomodoroTextArea>;

export const TextArea = forwardRef<HTMLTextAreaElement, TextAreaProps>(function DefaultTextArea(
  { name, ...props }: TextAreaProps,
  ref: Ref<HTMLTextAreaElement>
) {
  const sharedRef = useShareForwardedRef<HTMLTextAreaElement>(ref);

  const formik = useFormikContext();

  const [{ value }, { error, touched }, { setTouched, setValue }] = useField(name);

  // This useEffect is required, so we pick up the values
  // the user typed before the JS finishes loading
  useEffectOnce(() => {
    if (sharedRef.current?.value) {
      setValue(sharedRef.current.value);
      setTouched(true);
    }
  });

  return (
    <PomodoroTextArea
      ref={sharedRef}
      name={name}
      error={touched ? error : undefined}
      value={value || ''}
      onChange={formik.handleChange}
      onBlur={formik.handleBlur}
      {...props}
    />
  );
});
